import { cn } from '@/lib/cn';

/**
 * Avatar — iniciales sobre color derivado del nombre, o la foto si la hay.
 *
 * El par fondo/texto lo calcula `Utils.avatarColor`, que es el mismo que usan
 * las otras once pantallas del portal: la misma persona sale del mismo color en
 * el directorio, en el muro y en Inicio.
 *
 * Subió de `features/inicio/piezas.tsx` a `components/` el 2026-09-08, al
 * migrar Novedades: el muro pinta un avatar por publicación, otro por
 * comentario y otro en el compositor, y una segunda copia de esta función
 * habría sido la primera grieta por donde se rompe «la misma persona, el mismo
 * color».
 *
 * `insignia` existe para un solo caso real: el autor de sistema del muro, que
 * en vez de iniciales lleva el icono del edificio. Se pasa como hijo en vez de
 * cablearlo aquí porque quién es «sistema» lo decide la pantalla, no el avatar.
 */
export function Avatar({
  nombre, foto, tamano = 32, className, insignia,
}: {
  nombre?: string;
  foto?: string | null;
  /** Lado en píxeles. */
  tamano?: number;
  className?: string;
  /** Sustituye a las iniciales. Para el autor institucional del muro. */
  insignia?: React.ReactNode;
}) {
  const [fondo, tinta] = Utils.avatarColor(nombre || 'U');
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full',
        'text-2 font-bold',
        className,
      )}
      style={{ width: tamano, height: tamano, background: fondo, color: tinta }}
      aria-hidden="true"
    >
      {foto ? (
        <img src={foto} alt="" className="size-full object-cover" />
      ) : (
        insignia ?? Utils.avatarInitials(nombre || 'U')
      )}
    </span>
  );
}
